export default "__VITE_ASSET__DfiwUQXS__"